import DisplayFocusedValue from './displayFocusedValue.js';
export default DisplayFocusedValue;
